import {css, StyleSheet} from 'aphrodite';
import React, {useReducer} from 'react';

import Modal from 'ui-library/modals/Modal';

import reducer from './importInstrumentDataModalReducer';
import {InstrumentQueryStatus, INITIAL_STATE} from './InstrumentDataConstants';
import InstrumentLoginPage from './InstrumentLoginPage';

export interface InstrumentLoginPageModalProps {
  connectionId: string;
  onRequestSubmit: (username: string) => void;
  onRequestClose: () => void;
}

export default function InstrumentLoginPageModal(props: InstrumentLoginPageModalProps): JSX.Element {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  const buttons = [
    {
      text: 'Next',
      disabled: state.loginQueryStatus !== InstrumentQueryStatus.DONE,
      submit: true,
    },
  ];

  const submitHandler: () => void = () => {
    props.onRequestSubmit(state.loginUsername!);
  };

  return (
    <Modal
      buttons={buttons}
      closeableOnEscapeKey={false}
      large={true}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={submitHandler}
      title="Login"
    >
      <p className={css(styles.helpText)}>Login to generate and send your file.</p>
      <InstrumentLoginPage connectionId={props.connectionId} dispatch={dispatch} state={state} />
    </Modal>
  );
}

export const styles = StyleSheet.create({
  helpText: {
    'font-style': 'italic',
    padding: '10px 0 20px',
  },
});
